import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "../base/api-base.service";
import { ConnectorContractService } from "../interfaces/connector-contract.service";
import { NetworkStatusService } from "../network-status.service";
import { ConnectorOnlineService } from "../online/connector-online.service";
import { ConnectorOfflineService } from "../offline/connector-offline.service";

import { ConnectorStatus } from "../../_objects/connector";

@Injectable({
  providedIn: "root"
})
export class ConnectorService extends ApiService<ConnectorContractService> implements ConnectorContractService {
  constructor(
    protected networkStatusService: NetworkStatusService,
    protected offlineService: ConnectorOfflineService,
    protected onlineService: ConnectorOnlineService
  ) {
    super(networkStatusService, offlineService, onlineService);
  }

  getConnectorStatus(connectorId: string): Observable<ConnectorStatus> {
    return this.service.getConnectorStatus(connectorId);
  }
}
